import React from "react";

/**
 * Button DiWAD
 * @param {string} variant - "primary" | "secondary" | "danger" | "ghost"
 * @param {string} color   - override hex color (ex: "#FF6200")
 * @param {boolean} fullWidth
 * @param {boolean} loading
 */
export default function Button({
  children,
  variant = "primary",
  color,
  fullWidth = false,
  loading = false,
  className = "",
  ...props
}) {
  const base =
    "inline-flex items-center justify-center gap-2 font-bold rounded-[14px] transition-all active:opacity-75 tap-highlight select-none disabled:opacity-50 disabled:cursor-not-allowed";

  const variants = {
    primary: "bg-brand-orange text-white py-3.5 px-5 text-sm",
    blue: "bg-brand-blue text-white py-3.5 px-5 text-sm",
    secondary: "bg-white text-brand-dark border border-gray-200 py-3 px-5 text-sm",
    danger: "bg-brand-danger-light text-brand-danger border border-brand-danger-border py-3 px-5 text-sm",
    ghost: "bg-transparent text-gray-500 py-2.5 px-4 text-xs",
    success: "bg-brand-success text-white py-3.5 px-5 text-sm",
  };

  const style = color ? { backgroundColor: color } : {};

  return (
    <button
      className={`${base} ${variants[variant] || variants.primary} ${fullWidth ? "w-full" : ""} ${className}`}
      style={style}
      disabled={loading || props.disabled}
      {...props}
    >
      {loading ? (
        <span className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" />
      ) : null}
      {children}
    </button>
  );
}
